import { SelectionsWithQuantity } from "../types/pricing/price-display.types";

/**
 * Resolves and normalises the quantity within selections.
 * Merges `selections.quantity`, `selections.Quantity`, and an optional fallback
 * into a single canonical `quantity` field with only positive, comma-separated values.
 */
export const sanitizeSelections = (
  selections?: SelectionsWithQuantity,
  fallbackQuantity?: number,
): SelectionsWithQuantity | undefined => {
  const resolvedQuantity =
    selections?.quantity ??
    selections?.Quantity ??
    fallbackQuantity;

  const { quantity: _q1, Quantity: _q2, ...rest } =
    selections ?? {};

  const filteredQuantities = resolvedQuantity
    ? String(resolvedQuantity)
        .split(",")
        .map(q => q.trim())
        .filter(q => Number(q) > 0)
    : [];

  return filteredQuantities.length > 0
    ? { ...rest, quantity: filteredQuantities.join(",") }
    : Object.keys(rest).length > 0 ? rest : undefined;
};
